import styled from "styled-components"
import {ValidationButton as ValidationButtonBase} from "@irati/ui/src/FormItem"

const ValidationButton = styled(ValidationButtonBase)`
  width: 100px;
`

export default ValidationButton
